<div class="card preview-selector-card">
    <div class="card-body preview-selector-container d-flex flex-column flex-md-row">
        <label
            class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [for]="SPECIAL_OFFER_PREVIEW.INFO">
            <input
                class="d-none"
                type="radio"
                kendoRadioButton
                size="large"
                [id]="SPECIAL_OFFER_PREVIEW.INFO"
                name="answer"
                [value]="SPECIAL_OFFER_PREVIEW.INFO"
                [(ngModel)]="selectedTab"
                (ngModelChange)="tabChangeHandler()" />
            <i class="app-icon icon icon-contract-2 icon-xl"></i>
            <span>{{ 'specialOffers.preview.information.title' | translate }}</span>
        </label>

        <label
            class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [for]="SPECIAL_OFFER_PREVIEW.INSIGHTS">
            <input
                class="d-none"
                type="radio"
                kendoRadioButton
                size="large"
                [id]="SPECIAL_OFFER_PREVIEW.INSIGHTS"
                name="answer"
                [value]="SPECIAL_OFFER_PREVIEW.INSIGHTS"
                [(ngModel)]="selectedTab"
                (ngModelChange)="tabChangeHandler()" />
            <i class="app-icon icon icon-analytics icon-xl"></i>
            <span>{{ 'specialOffers.preview.insights.title' | translate }}</span>
        </label>
    </div>
</div>
